import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./app";
import "./i18n";

// 👉 AJOUT 1 : import du tracker
import RouteChangeTracker from "./analytics/RouteChangeTracker";

declare global {
  interface Window {
    __INITIAL_DATA__?: { isAuthenticated?: boolean; url?: string };
  }
}

const isAuthenticated = window.__INITIAL_DATA__?.isAuthenticated || false;
const url = window.__INITIAL_DATA__?.url || "/";

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <HelmetProvider>
      <BrowserRouter>
        {/* 👉 AJOUT 2 : tracker déclenché à chaque navigation */}
        <RouteChangeTracker />

        <Suspense fallback={<div>Loading...</div>}>
          <App isAuthenticated={isAuthenticated} url={url} />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}
